import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService
} from 'app/services';
import {
  confirmDialog,
  actionIcon,
  alerts
} from 'app/components/global';
import controller from './nonitAsset.controller';
import directive from './nonIT-Asset.directive';

export default angular.module('app.components.advisory.enterpriseModeling.nonitAsset', [
  actionIcon,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  assetDataService,
])
  .directive('emNonItAsset', directive)
  .controller('NonITAssetController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.nonitAsset created');
